import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const STORAGE_KEY = "cookieConsentAccepted";

const Banner = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  padding: 20px 30px;
  background: #ffffff;
  box-shadow: 0 -4px 24px rgba(29, 29, 29, 0.15);

  @media (max-width: 728px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 14px;
    padding: 16px;
  }
`;

const Text = styled.div`
  flex: 1;
  min-width: 0;
  max-width: 900px;
  font-family: "SteppeRegular", sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: #1d1d1d;

  a {
    color: var(--green);
    font-weight: 600;
    text-decoration: underline;
    white-space: nowrap;
    cursor: pointer;

    &:hover {
      color: #f74f38;
    }
  }
`;

const AcceptButton = styled.button`
  flex-shrink: 0;
  padding: 12px 30px;
  border: none;
  border-radius: 12px;
  background: linear-gradient(91.37deg, #f74f38 0%, #e3371f 100%);
  font-family: RfdBold, sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: white;
  cursor: pointer;
  user-select: none;
  transition: opacity 0.2s linear;

  &:hover {
    opacity: 0.85;
  }

  @media (max-width: 728px) {
    width: 100%;
  }
`;

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem(STORAGE_KEY);
    if (!accepted) setVisible(true);
  }, []);

  const handleAccept = () => {
    localStorage.setItem(STORAGE_KEY, "true");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <Banner>
      <Text>
        Мы используем файлы cookie для улучшения работы сайта и повышения
        удобства пользователей. Продолжая пользоваться сайтом, вы соглашаетесь
        с использованием cookie в соответствии с{" "}
        <Link to="/privacy-policy">политикой конфиденциальности</Link>.
      </Text>
      <AcceptButton onClick={handleAccept}>Принять</AcceptButton>
    </Banner>
  );
};

export default CookieConsent;
